/* eslint-disable react/prop-types */
/* eslint-disable no-return-assign */
/* eslint-disable react/state-in-constructor */
// @ts-nocheck

import { getNominative } from 'common/utils'
import Form from 'components/forms'
import { AvatarUpload, ProfilePicture } from 'components/generic'
import Operations from 'operations'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { history } from 'store'
import styled from 'styled-components'

const FORM_ID = 'editResident'

export class EditableProfilePicture extends React.Component {
  state = { imageUploadOpen: false }

  formRef = null

  setFormRef = (node) => (this.formRef = node)

  handleComplete = (resident) => {
    const { showToast, preferredPeopleNominative } = this.props
    showToast({
      title: `Updated a ${getNominative(preferredPeopleNominative, 'Resident')}`
    })
    this.props.queryClient.invalidateQueries(['resident'])
    history.push(`/residents/${resident.id}/profile`)
  }

  handleSubmit = () => {
    const { fields, updateItem, showToast, preferredPeopleNominative } =
      this.props
    updateItem({
      url: `list/residents/${fields.id}`,
      onComplete: this.handleComplete,
      onError: () => {
        showToast({
          type: 'error',
          title: `Could not update the ${getNominative(
            preferredPeopleNominative,
            'Resident'
          )}`
        })
      }
    })
  }

  handleImageSave = (file, imageUri) => {
    this.props.addFormFile({ key: 'picture', file, uri: imageUri })
    this.handleSubmit()
  }

  render() {
    const { fields, files, profile, testId, disabled } = this.props
    const { imageUploadOpen } = this.state

    if (!fields) return null

    const picture = files?.picture?.uri || fields.picture

    return (
      <div
        ref={this.setFormRef}
        data-testid={
          testId
            ? `${testId}-editable-profile-picture`
            : 'editable-profile-picture'
        }
      >
        <Wrapper
          data-testid={
            testId
              ? `${testId}-profile-picture-wrapper`
              : 'profile-picture-wrapper'
          }
        >
          <ProfilePicture
            edit={!disabled && profile?.status !== 'dummy'}
            onClick={() =>
              !disabled && this.setState({ imageUploadOpen: true })
            }
            size={140}
            style={imageStyle}
            url={picture}
            data-testid={
              testId ? `${testId}-profile-picture` : 'profile-picture'
            }
          />
        </Wrapper>
        <AvatarUpload
          customButton
          isModalOpen={!disabled && imageUploadOpen}
          onSave={this.handleImageSave}
          onClose={() => this.setState({ imageUploadOpen: false })}
          data-testid={testId ? `${testId}-avatar-upload` : 'avatar-upload'}
        />
      </div>
    )
  }
}

const Wrapper = styled.div`
  margin: 0;
  max-width: childScreen;
`

const imageStyle = {
  position: 'relative',
  zIndex: 1,
  overflow: 'hidden'
}

EditableProfilePicture.propTypes = {
  deleteSelf: PropTypes.func.isRequired,
  features: PropTypes.object,
  testId: PropTypes.string
}

const mapStateToProps = (state) => ({
  preferredPeopleNominative: state.global.home.preferredPeopleNominative,
  user: state.global.user
})

const mapDispatchToProps = (dispatch) => ({
  deleteSelf: ({ id, onComplete }) =>
    dispatch(Operations.deleteFormItem({ id, list: 'residents', onComplete }))
})

const wrappedForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditableProfilePicture)

export default Form(wrappedForm, FORM_ID)
